import React from 'react';
import classes from './style.module.scss';
import Hamburger from '../../media/hamburger.svg';
import Logo from '../Logo/Logo';

const Nav = ({ onClick }) => {
    const path = window.location.pathname;

    const getNavClassName = () => {
        if (path.startsWith('/menu') || path === '/') {
            return classes.nav;
        }
        if (path.startsWith('/shop')) {
            return `${classes.nav} ${classes.navBackground} ${classes.navIndex}`;
        }
        return `${classes.nav} ${classes.navBackground}`;
    };

    return (
        <nav className={getNavClassName()}>
            <div>
                <div className={classes.header}>
                    <Logo />
                    <div>
                        <img
                            onClick={onClick}
                            className={classes.navButton}
                            src={Hamburger}
                            alt="hamburger"
                        />
                        <a
                            href="tel:+79672775974"
                            className={classes.phoneNumber}
                        >
                            +7-967-277-59-74
                        </a>
                        <p>ул. Комсомольская, д. 25</p>
                    </div>
                </div>
                <div className={classes.items}>
                    <a className={classes.item} href="/">
                        Главная
                    </a>
                    <a className={classes.item} href="/menu">
                        Меню
                    </a>
                    <a className={classes.item} href="/news">
                        Новости
                    </a>
                    {/*<a className={classes.item} href="/shop">*/}
                    {/*    Магазин*/}
                    {/*</a>*/}
                    <a className={classes.item} href="/plan">
                        План зала
                    </a>
                    <a className={classes.item} href="/contacts">
                        Контакты
                    </a>
                    <a className={classes.item} href="/promo">
                        Акции
                    </a>
                    <a className={classes.item} href="/tournaments">
                        Турниры
                    </a>
                </div>
            </div>
        </nav>
    );
};

export default Nav;
